// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avenue -> pillar-properties-avenue -> the-lex
// Generated: 2026-11-02T22:33:47.756Z
// Counts: 3 design, 29 content, 23 slot group, 3 collection binding, 10 section, 0 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design.block:privacy-consent.color.surface": {
    "cssVariable": "--vibe-color-surface",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  },
  "design.block:privacy-consent.color.text": {
    "cssVariable": "--vibe-color-text",
    "overrideType": "VALUE",
    "value": "#ffffff",
    "mappedField": null
  }
};

export const contentOverrides = {
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_full_address"
  },
  "footer.copyright": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_copyright"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": "virtual tour",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_name"
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hyperlocal-links.show_header": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "Your New Home Awaits",
    "generatedValue": null,
    "mappedField": null
  },
  "socialfollow.instagram_embed": {
    "overrideType": "VALUE",
    "customValue": "instagram-oembed",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019db20d-c5fe-74c9-9e46-594189b77fe3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Lex in Tacoma, luxury meets comfort with inviting <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.thelextacoma.com/floor-plans\">studio, one-bedroom, and two-bedroom</a> floor plans. Enjoy stunning quartz counters, soft-close cabinets, and unwind in our exclusive Sky Lounge. Experience a lifestyle tailored to you in a vibrant community that feels like home. Join us today!</p><ul><li><p></p></li></ul><p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "At The Lex in Tacoma, find the perfect home tailored to your lifestyle with our diverse floor plans, including stylish studios, spacious one-bedrooms, and inviting two-bedroom units. Ready to learn more about your future sanctuary? Our leasing team is just a message away—connect with us today!",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Lex, where urban living meets vibrant community life in Tacoma! Choose from cozy studios to spacious two-bedroom apartments. Enjoy proximity to cultural gems like the Museum of Glass, Point Defiance Zoo &amp; Aquarium, and Tacoma Community College, ensuring your lifestyle is as inspiring as your surroundings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Tacoma is the place to be, and The Lex is perfectly situated – close to the Sounder Transit Station, shopping, dining, and entertainment. Easy commute to downtown Seattle and close to Joint Base Lewis-McChord, MultiCare Health System Tacoma, and the University of Washington Tacoma. Catch sweeping views of Commencement Bay from almost every apartment home at The Lex, if that’s still not enough, take it all in from the expansive rooftop deck. Featuring a Walk Score of 96, The Lex is a walker’s paradise – an easy stroll to a variety of restaurants and retail. The spacious apartments at The Lex feature high end finishes, tall ceilings, large kitchens and bathrooms, private patios along with resident lounges, and fitness center.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into modern living at The Lex in Tacoma, where stylish <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">studio, one-bedroom, and two-bedroom apartments</a> await. Each thoughtfully designed floor plan complements your lifestyle. Ready to envision your new home? Take a virtual tour of our vibrant community and find the perfect space that resonates with you!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-49a5-7587-b84e-e2aedab919be.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "footer.powered_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d6d9d-fa1c-74bf-a89d-68fd979db7af.webp"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour"
      }
    }
  },
  "interactive-map-hero.bg_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "resident-access-hero.bg_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "ctasection.card1_image": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "ctasection.card3_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": 0,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": 15,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      3,
      6
    ],
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      10,
      6,
      12
    ],
    "ordering": null,
    "customItems": null
  },
  "reviewscallout.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "privacy-consent",
      "blockId": "privacy-consent",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 8
    }
  ],
  "home": [
    {
      "sectionId": "hyperlocal-links",
      "blockId": "hyperlocal-links",
      "position": 12
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 8
    }
  ]
};

export const styleOverrides = {};
